import React, { createContext, useContext, useState } from 'react';
import { ILocationContext } from './../model/Locations.model';
import { Location } from '../model/Locations.model';

export const LocationsProvider = ({ children }: { children: React.ReactNode }) => {
  const [currentLocation, setCurrentLocation] = useState<Location | undefined>(undefined);

  return (
    <LocationContext.Provider value={{ currentLocation, setCurrentLocation, locations: [], locationsContainIaas: false }}>
      {children}
    </LocationContext.Provider>
  );
};

export const LocationContext = createContext<ILocationContext | null>(null);

export const useLocations = () => {
  const context = useContext(LocationContext);
  if (!context) {
    throw new Error('useLocations must be used within a LocationsProvider');
  }
  return {
    currentLocation: context.currentLocation,
    locations: context.locations,
    setCurrentLocation: context.setCurrentLocation,
    locationsContainIaas: context.locationsContainIaas,
  };
};
